/**
 * Nexcar expediente document categories and metadata for purchase order flows.
 */

export const NEXCAR_EXPEDIENTE_RESOURCE_CLASS_PURCHASE_ORDER = "PurchaseOrder" as const;

export const NEXCAR_DOCUMENT_CATEGORY_INVOICE = "purchase_order_invoice_process_evidence" as const;
export const NEXCAR_DOCUMENT_CATEGORY_ENDORSEMENT = "purchase_order_invoice_endorsement" as const;
export const NEXCAR_DOCUMENT_CATEGORY_CIRCULATION = "purchase_order_circulation_card" as const;
export const NEXCAR_DOCUMENT_CATEGORY_REPORT = "purchase_order_nexcar_report" as const;
export const NEXCAR_DOCUMENT_CATEGORY_BAJA_VEHICULAR = "purchase_order_cancellation_procedure" as const;
export const NEXCAR_DOCUMENT_TYPE_REPORT = "nexcar_report" as const;
export const NEXCAR_UPLOAD_DIRECTION_RECEIVED = "received" as const;
export const NEXCAR_REVIEW_STATUS_APPROVED = "aprobado" as const;
export const NEXCAR_REVIEW_STATUS_REJECTED = "rechazado" as const;
export const NEXCAR_REVIEW_STATUS_PENDING = "pendiente" as const;
export const NEXCAR_REVIEW_STATUS_CANCELED = "cancelado" as const;

/** Value for payment_proof_of when uploading endorsement documents */
export const NEXCAR_ENDORSEMENT_PAYMENT_PROOF_OF = NEXCAR_DOCUMENT_CATEGORY_ENDORSEMENT;

export type NexcarMetadataCategoryFilter = Record<string, Record<string, unknown>>;

/**
 * When false, Nexcar PO UI hides the endorsement (endosos) step and card and skips uploading that category.
 * Set to true to restore endorsements in the flow.
 */
export const NEXCAR_ENDORSEMENTS_UI_ENABLED = false;

/**
 * Metadata filters for DocumentsService.getDocumentsByMetadata on purchase orders.
 * Respects {@link NEXCAR_ENDORSEMENTS_UI_ENABLED} (omits endorsement category when disabled).
 */
export function getNexcarMetadataFiltersForPurchaseOrder(): NexcarMetadataCategoryFilter[] {
  if (NEXCAR_ENDORSEMENTS_UI_ENABLED) {
    return [
      { [NEXCAR_DOCUMENT_CATEGORY_INVOICE]: {} },
      { [NEXCAR_DOCUMENT_CATEGORY_ENDORSEMENT]: {} },
      { [NEXCAR_DOCUMENT_CATEGORY_CIRCULATION]: {} },
      { [NEXCAR_DOCUMENT_CATEGORY_BAJA_VEHICULAR]: {} },
    ];
  }
  return [
    { [NEXCAR_DOCUMENT_CATEGORY_INVOICE]: {} },
    { [NEXCAR_DOCUMENT_CATEGORY_CIRCULATION]: {} },
    { [NEXCAR_DOCUMENT_CATEGORY_BAJA_VEHICULAR]: {} },
  ];
}

/** Full list including endorsement; prefer getNexcarMetadataFiltersForPurchaseOrder() for PO fetches. */
export const NEXCAR_METADATA_FILTERS_FOR_PURCHASE_ORDER: readonly NexcarMetadataCategoryFilter[] = [
  { [NEXCAR_DOCUMENT_CATEGORY_INVOICE]: {} },
  { [NEXCAR_DOCUMENT_CATEGORY_ENDORSEMENT]: {} },
  { [NEXCAR_DOCUMENT_CATEGORY_CIRCULATION]: {} },
  { [NEXCAR_DOCUMENT_CATEGORY_BAJA_VEHICULAR]: {} },
];

export const NEXCAR_METADATA_FILTERS_PROBES: readonly NexcarMetadataCategoryFilter[] = [
  ...NEXCAR_METADATA_FILTERS_FOR_PURCHASE_ORDER,
  { [NEXCAR_DOCUMENT_CATEGORY_REPORT]: {} },
];

export const NEXCAR_UPLOAD_ORIGIN_METADATA_KEY = "nexcar_upload_origin" as const;
export const NEXCAR_UPLOAD_ORIGIN_NEXTCAR_DOCS = "purchase_order_nextcar_docs_steps" as const;
export const INCIDENT_INCORRECT_NEXCAR_EXPEDIENTE = "incorrect_nexcar_expediente" as const;
export const NEXCAR_CREATE_EXPEDIENTE_SYSTEM_PROCESS_NAME = "Crear expedientes en Nexcar" as const;
